import { business } from "../data/business";

type Variant = "inline" | "stacked";

// Single source of truth for rendering the business address. Prevents
// stray-comma / whitespace bugs from showing up across components.
export function AddressLine({ variant = "inline" }: { variant?: Variant }) {
  const { street, city, state, zip } = business.address;

  if (variant === "stacked") {
    return (
      <span className="address-stacked">
        <span>{street}</span>
        <span>{`${city}, ${state} ${zip}`}</span>
      </span>
    );
  }
  return <span>{`${street}, ${city}, ${state} ${zip}`}</span>;
}
